export const indWVsIreWMyAnswersList = [
  {
    id: '63f3278248811c001df891eb',
    answer: true,
    isPowerUp: false,
    questions: {
      english: ' Will Smriti Mandhana score more than 28 runs?',
      hindi: ' क्या स्मृति मंधाना 28 से ज्यादा रन बनाएंगी?'
    },
    sequence: 1,
    insights: {
      english: "Smriti Mandhana's average in T20Is - 27.85",
      hindi: 'T20Is में स्मृति मंधाना का औसत - 27.85 है'
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ec',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Harmanpreet Kaur face more than 20 balls?',
      hindi: 'क्या हरमनप्रीत कौर 20 से ज्यादा गेंदों का सामना करेंगी?'
    },
    sequence: 2,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ed',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Radha Yadav get a wicket?',
      hindi: 'क्या राधा यादव को विकेट मिलेगा?'
    },
    sequence: 3,
    insights: {
      english: 'Radha Yadav has picked up 65 wickets in 60 T20Is',
      hindi: 'राधा यादव ने 60 T20I में 65 विकेट लिए हैं'
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ee',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Deepti Sharma concede more than 18 runs?',
      hindi: 'क्या दीप्ति शर्मा 18 से ज्यादा रन देंगी?'
    },
    sequence: 4,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ef',
    answer: true,
    isPowerUp: false,
    questions: {
      english: ' Will Harmanpreet Kaur bat with a strike rate of 120 or more?',
      hindi: 'क्या हरमनप्रीत कौर 120 या उससे ज्यादा के स्ट्राइक रेट से बल्लेबाजी करेंगी?'
    },
    sequence: 5,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f0',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will the team batting first score more than 145 runs?',
      hindi: 'क्या पहले बल्लेबाजी करने वाली टीम 145 से ज्यादा रन बनाएगी?'
    },
    sequence: 6,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f1',
    answer: true,
    isPowerUp: true,
    questions: {
      english: 'Will Sneh Rana get more than 1 wicket?',
      hindi: ' क्या स्नेह राणा को 1 से ज्यादा विकेट मिलेंगे?'
    },
    sequence: 7,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f2',
    answer: true,
    isPowerUp: true,
    questions: {
      english: 'Will Renuka Thakur pick more than 1 wicket?',
      hindi: 'क्या रेणुका ठाकुर 1 से अधिक विकेट लेंगी?'
    },
    sequence: 8,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f3',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Renuka Thakur pick more wicket than Deepti Sharma?',
      hindi: 'क्या रेणुका ठाकुर लेंगी दीप्ति शर्मा से ज्यादा विकेट?'
    },
    sequence: 9,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f4',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Harmanpreet Kaur score more runs than Smriti Mandhana?',
      hindi: 'क्या स्मृति मंधाना से ज्यादा रन बनाएंगी हरमनप्रीत कौर?'
    },
    sequence: 10,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  }
];
export const kolVsLsgAnswersList = [
  {
    _id: '62848af9f19d86001d6bf939',
    questions: {
      english: 'Can Quinton de Kock get a 50+ score against Kolkata?',
      hindi: 'क्या क्विंटन डी कॉक कोलकाता के खिलाफ 50 से ज्यादा रन बनाएंगे?'
    },
    insights: {
      english:
        'Quinton de Kock this season - Runs - 362 Highest score - 80 Average - 27.85 Quinton de Kock against Kolkata this season - Runs - 50 Strike Rate - 172.41',
      hindi:
        'क्विंटन डी कॉक इस सीजन - रन - 362 उच्चतम स्कोर - 80 औसत - 27.85 इस सीजन में कोलकाता के खिलाफ क्विंटन डी कॉक - रन - 50 स्ट्राइक रेट - 172.41'
    },
    imageUrl: '',
    sequence: 1,
    isAnswered: true,
    isValid: true,
    answer: true,
    id: '62848af9f19d86001d6bf939'
  },
  {
    _id: '62848af9f19d86001d6bf93a',
    questions: {
      english: 'Will Kolkata Win Their Third Straight Game Today?',
      hindi: 'क्या आज कोलकाता अपना लगातार तीसरा गेम जीतेगी?'
    },
    insights: {
      english:
        'Kolkata won the last two games but Lucknow beat Kolkata in the last head-to-head game by 75 runs!',
      hindi:
        'कोलकाता ने पिछले दो गेम जीते है. लेकिन लखनऊ ने आखिरी गेम में कोलकाता को 75 रन से हराया!'
    },
    imageUrl: '',
    sequence: 2,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf93a'
  },
  {
    _id: '62848af9f19d86001d6bf93b',
    questions: {
      english: 'Can Andre Russell pick up more than 1 wicket and get 25+ runs today?',
      hindi: 'क्या आंद्रे रसेल आज 1 से अधिक विकेट ले सकते हैं और 25+ रन बना सकते हैं?'
    },
    insights: {
      english:
        'Andre Russell this season - Runs - 330 Highest score - 70* Wickets - 17 Andre Russell against Lucknow this season - Runs - 45 Strike rate - 237.84 Wickets - 2',
      hindi:
        'इस सीजन में आंद्रे रसेल - रन - 330 उच्चतम स्कोर - 70* विकेट - 17 इस सीजन में लखनऊ के खिलाफ आंद्रे रसेल - रन - 45 स्ट्राइक रेट - 237.84 विकेट - 2'
    },
    imageUrl: '',
    sequence: 3,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf93b'
  },
  {
    _id: '62848af9f19d86001d6bf93c',
    questions: {
      english: 'Will a spinner take the wicket of Shreyas Iyer today?',
      hindi: 'क्या आज श्रेयस अय्यर स्पिनर को फिर से अपना विकेट देंगे?'
    },
    insights: {
      english:
        'Shreyas Iyer against spinners this season -  Innings - 10 Balls faced - 108 Dismissals - 6',
      hindi:
        'श्रेयस अय्यर इस सीजन में स्पिनरों के खिलाफ- पारी - 10 गेंदों का सामना करना पड़ा - 108 आउट - 6'
    },
    imageUrl: '',
    sequence: 4,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf93c'
  },
  {
    _id: '62848af9f19d86001d6bf93d',
    questions: {
      english: 'Can KL Rahul score 50+ runs today?',
      hindi: 'क्या केएल राहुल आज 50 से ज्यादा रन बनाएंगे?'
    },
    insights: {
      english: 'KL Rahul this season -  Runs - 469 Average - 42.64 Highest score - 103',
      hindi: 'केएल राहुल इस सीजन - रन - 469 औसत - 42.64 उच्चतम स्कोर - 103'
    },
    imageUrl: '',
    sequence: 5,
    isAnswered: true,
    isValid: true,
    answer: true,
    id: '62848af9f19d86001d6bf93d'
  },
  {
    _id: '62848af9f19d86001d6bf93e',
    questions: {
      english: 'Will Umesh Yadav pick up more than 1 wicket in his first spell?',
      hindi: 'क्या उमेश यादव अपने पहले स्पेल में 1 से ज्यादा विकेट लेंगे?'
    },
    insights: {
      english:
        'Umesh Yadav in the first 6 overs (in powerplay) this season -  Wickets - 8 Economy - 6.10 ',
      hindi: 'उमेश यादव इस सीजन के पहले स्पेल में - विकेट - 8 Economy- 6.10'
    },
    imageUrl: '',
    sequence: 6,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf93e'
  },
  {
    _id: '62848af9f19d86001d6bf93f',
    questions: {
      english: 'Sunil Narine to concede 30 or more runs in the match?',
      hindi: 'मैच में 30 या इससे ज्यादा रन देंगे सुनील नरेन?'
    },
    insights: {
      english:
        'Sunil Narine this season -  Economy - 5.48 Wickets - 9 Balls bowled - 312 Sunil Narine against Lucknow this season -  Economy - 5 Wickets - 1 Runs conceded - 20',
      hindi:
        'सुनील नरेन इस सीजन - अर्थव्यवस्था - 5.48 विकेट - 9 गेंद फेंकी - 312 इस सीजन में लखनऊ के खिलाफ सुनील नारायण - Economy- 5 विकेट - 1 रन दीये - 20'
    },
    imageUrl: '',
    sequence: 7,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf93f'
  },
  {
    _id: '62848af9f19d86001d6bf940',
    questions: {
      english: 'Can Andre Russell smash more than 3 sixes today?',
      hindi: 'क्या आज आंद्रे रसेल 3 से ज्यादा छक्के लगा सकते हैं?'
    },
    insights: {
      english:
        'Andre Russell this season -  Total 6s - 32 Most sixes in one match - 8 Strike rate - 182.32 Andre Russell against Lucknow this season - Total 6s - 5 Total 4s - 3',
      hindi:
        'इस सीजन में आंद्रे रसेल - कुल 6s - 32 एक मैच में सर्वाधिक छक्के - 8 स्ट्राइक रेट - 182.32 इस सीजन में लखनऊ के खिलाफ आंद्रे रसेल - कुल 6s - 5 कुल 4s - 3'
    },
    imageUrl: '',
    sequence: 8,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf940'
  },
  {
    _id: '62848af9f19d86001d6bf941',
    questions: {
      english: 'Can Deepak Hooda get another 30+ score?',
      hindi: 'क्या दीपक हुड्डा को एक और 30 से ज्यादा रन बनाएंगे?'
    },
    insights: {
      english: 'Deepak Hooda this season -  Runs - 409 Highest score - 59 Average - 31.23',
      hindi: 'इस सीजन में दीपक हुड्डा- रन - 409 उच्चतम स्कोर - 59 औसत - 31.23'
    },
    imageUrl: '',
    sequence: 9,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf941'
  },
  {
    _id: '62848af9f19d86001d6bf942',
    questions: {
      english: 'Will Avesh Khan pick up more than 2 wickets today?',
      hindi: 'क्या आज आवेश खान 2 से ज्यादा विकेट लेंगे?'
    },
    insights: {
      english:
        'Avesh Khan this season - Wickets - 17 Average - 18.35 Best figures - 4/24 Avesh Khan against Kolkata this season - Wickets - 3 Maiden Overs - 1 Economy - 6.33',
      hindi:
        'इस सीजन में अवेश खान - विकेट - 17 औसत - 18.35 सर्वश्रेष्ठ आंकड़े - 4/24 इस सीजन में कोलकाता के खिलाफ अवेश खान - विकेट - 3 मेडेन ओवर - 1 अर्थव्यवस्था - 6.33'
    },
    imageUrl: '',
    sequence: 10,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '62848af9f19d86001d6bf942'
  }
];
export const punVsDcAnswersList = [
  {
    _id: '628241eb92265b0020539777',
    questions: {
      english: 'Will Punjab Kings score more than 50 runs in the powerplay?',
      hindi: 'क्या पंजाब किंग्स पावरप्ले में 50 से ज्यादा रन बनाएगी?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn1.jpg',
    sequence: 1,
    isAnswered: true,
    isValid: true,
    answer: 'false',
    id: '628241eb92265b0020539777'
  },
  {
    _id: '628241eb92265b0020539778',
    questions: {
      english: 'Can Mayank Agarwal score 19 or more runs today?',
      hindi: 'क्या मयंक अग्रवाल आज 19 या उससे अधिक रन बना सकते हैं?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn11.jpg',
    sequence: 2,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b0020539778'
  },
  {
    _id: '628241eb92265b0020539779',
    questions: {
      english: 'Will David Warner shine against Punjab with a 50+ score?',
      hindi: 'क्या डेविड वॉर्नर आज 50+ स्कोर करेंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn8.jpg',
    sequence: 3,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b0020539779'
  },
  {
    _id: '628241eb92265b002053977a',
    questions: {
      english: 'Will Jonny Bairstow and Shikhar Dhawan build a 40+ run partnership?',
      hindi: 'क्या जॉनी बेयरस्टो और शिखर धवन 40+ रन की साझेदारी बनाएंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn14.jpg',
    sequence: 4,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977a'
  },
  {
    _id: '628241eb92265b002053977b',
    questions: {
      english: 'Will Shikhar Dhawan score above 40 runs today?',
      hindi: 'क्या आज शिखर धवन का स्कोर 40 रन से ऊपर होगा?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn10.jpg',
    sequence: 5,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977b'
  },
  {
    _id: '628241eb92265b002053977c',
    questions: {
      english: 'Will Mitch Marsh take 1 wicket and get a 25+ score?',
      hindi: 'क्या मिच मार्श 1 विकेट लेंगे और 25+ स्कोर प्राप्त करेंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn7.jpg',
    sequence: 6,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977c'
  },
  {
    _id: '628241eb92265b002053977d',
    questions: {
      english: 'Will Liam Livingstone hit more than 3 fours today?',
      hindi: 'क्या लियाम लिविंगस्टोन आज 3 चौके से ज्यादा लगाएंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn17.jpg',
    sequence: 7,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977d'
  },
  {
    _id: '628241eb92265b002053977e',
    questions: {
      english: 'Will there be more than 1 run outs today?',
      hindi: 'क्या आज 1 से अधिक रन आउट होंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn5.jpg',
    sequence: 8,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977e'
  },
  {
    _id: '628241eb92265b002053977f',
    questions: {
      english: 'Will there be a maiden over today?',
      hindi: 'क्या आज मेडन ओवर होगी?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn16.jpg',
    sequence: 9,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977f'
  },
  {
    _id: '628241eb92265b0020539780',
    questions: {
      english: 'Will Kagiso Rabada pick up 1 wicket in the powerplay?',
      hindi: 'क्या पावरप्ले में कगिसो रबाडा लेंगे 1 विकेट?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn3.jpg',
    sequence: 10,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b0020539780'
  }
];
export const indWVsNzWMyAnswersList = [
  {
    id: '63f3278248811c001df891eb',
    answer: true,
    isPowerUp: false,
    questions: {
      english: ' Will Shubman Gill score more than 28 runs?',
      hindi: 'क्या शुभमन गिल 28 से ज्यादा रन बनाएंगे?'
    },
    sequence: 1,
    insights: {
      english: "Shubman Gill's average in T20Is - 40.4",
      hindi: 'T20I में शुभमन गिल का औसत - 28 रन से 40.4 करोड़ अधिक?'
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ec',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Rahul Tripathi more than 20 balls?',
      hindi: 'क्या राहुल त्रिपाठी 20 गेंदों से ज्यादा करेंगे?'
    },
    sequence: 2,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ed',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Ish Sodhi get a wicket?',
      hindi: 'क्या ईश सोढ़ी को मिलेगा विकेट?'
    },
    sequence: 3,
    insights: {
      english: 'Ish Sodhi has picked up 114 wickets in 91 T20Is',
      hindi: 'ईश सोढ़ी ने 91 टी20 मैचों में 114 विकेट लिए हैं'
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ee',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Umran Malik concede more than 18 runs?',
      hindi: 'क्या उमरान मलिक देंगे 18 से ज्यादा रन?'
    },
    sequence: 4,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891ef',
    answer: true,
    isPowerUp: false,
    questions: {
      english: ' Will Devon Conway bat with a strike rate of 120 or more?',
      hindi: 'क्या डेवोन कॉनवे 120 या अधिक के स्ट्राइक रेट से बल्लेबाजी करेंगे?'
    },
    sequence: 5,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f0',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will the team batting first score more than 145 runs?',
      hindi: 'क्या पहले बल्लेबाजी करने वाली टीम 145 से ज्यादा रन बनाएगी?'
    },
    sequence: 6,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f1',
    answer: true,
    isPowerUp: true,
    questions: {
      english: 'Will Hardik Pandya get more than 1 wicket?',
      hindi: 'क्या हार्दिक पांड्या को मिलेंगे 1 से ज्यादा विकेट?'
    },
    sequence: 7,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f2',
    answer: true,
    isPowerUp: true,
    questions: {
      english: 'Will Mitchell Santner pick more than 1 wicket?',
      hindi: 'क्या मिचेल सेंटनर 1 से अधिक विकेट लेंगे?'
    },
    sequence: 8,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f3',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Hardik Pandya pick more wicket than Ish Sodhi?',
      hindi: 'क्या ईश सोढ़ी से ज्यादा विकेट लेंगे हार्दिक पंड्या?'
    },
    sequence: 9,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  },
  {
    id: '63f3278248811c001df891f4',
    answer: true,
    isPowerUp: false,
    questions: {
      english: 'Will Suryakumar Yadav score more runs than Daryl Mitchell?',
      hindi: 'क्या सूर्यकुमार यादव डेरिल मिशेल से ज्यादा रन बनाएंगे?'
    },
    sequence: 10,
    insights: {
      english: '',
      hindi: ''
    },
    imageUrl: ''
  }
];

export const nzVsPakMyAnswersList = [
  {
    _id: '628241eb92265b0020539777',
    questions: {
      english: 'Will Punjab Kings score more than 50 runs in the powerplay?',
      hindi: 'क्या पंजाब किंग्स पावरप्ले में 50 से ज्यादा रन बनाएगी?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn1.jpg',
    sequence: 1,
    isAnswered: true,
    isValid: true,
    answer: 'false',
    id: '628241eb92265b0020539777'
  },
  {
    _id: '628241eb92265b0020539778',
    questions: {
      english: 'Can Mayank Agarwal score 19 or more runs today?',
      hindi: 'क्या मयंक अग्रवाल आज 19 या उससे अधिक रन बना सकते हैं?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn11.jpg',
    sequence: 2,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b0020539778'
  },
  {
    _id: '628241eb92265b0020539779',
    questions: {
      english: 'Will David Warner shine against Punjab with a 50+ score?',
      hindi: 'क्या डेविड वॉर्नर आज 50+ स्कोर करेंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn8.jpg',
    sequence: 3,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b0020539779'
  },
  {
    _id: '628241eb92265b002053977a',
    questions: {
      english: 'Will Jonny Bairstow and Shikhar Dhawan build a 40+ run partnership?',
      hindi: 'क्या जॉनी बेयरस्टो और शिखर धवन 40+ रन की साझेदारी बनाएंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn14.jpg',
    sequence: 4,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977a'
  },
  {
    _id: '628241eb92265b002053977b',
    questions: {
      english: 'Will Shikhar Dhawan score above 40 runs today?',
      hindi: 'क्या आज शिखर धवन का स्कोर 40 रन से ऊपर होगा?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn10.jpg',
    sequence: 5,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977b'
  },
  {
    _id: '628241eb92265b002053977c',
    questions: {
      english: 'Will Mitch Marsh take 1 wicket and get a 25+ score?',
      hindi: 'क्या मिच मार्श 1 विकेट लेंगे और 25+ स्कोर प्राप्त करेंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn7.jpg',
    sequence: 6,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977c'
  },
  {
    _id: '628241eb92265b002053977d',
    questions: {
      english: 'Will Liam Livingstone hit more than 3 fours today?',
      hindi: 'क्या लियाम लिविंगस्टोन आज 3 चौके से ज्यादा लगाएंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn17.jpg',
    sequence: 7,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977d'
  },
  {
    _id: '628241eb92265b002053977e',
    questions: {
      english: 'Will there be more than 1 run outs today?',
      hindi: 'क्या आज 1 से अधिक रन आउट होंगे?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn5.jpg',
    sequence: 8,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b002053977e'
  },
  {
    _id: '628241eb92265b002053977f',
    questions: {
      english: 'Will there be a maiden over today?',
      hindi: 'क्या आज मेडन ओवर होगी?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn16.jpg',
    sequence: 9,
    isAnswered: true,
    isValid: true,
    answer: false,
    id: '628241eb92265b002053977f'
  },
  {
    _id: '628241eb92265b0020539780',
    questions: {
      english: 'Will Kagiso Rabada pick up 1 wicket in the powerplay?',
      hindi: 'क्या पावरप्ले में कगिसो रबाडा लेंगे 1 विकेट?'
    },
    insights: {
      english: 'Delhi has a slight edge over Punjab - PBKS 14-15 DC',
      hindi: 'पंजाब पर दिल्ली की थोड़ी बढ़त हैं - PBKS 14-15 DC'
    },
    imageUrl: 'https://images-v1.igamio.com/banner-images/yn3.jpg',
    sequence: 10,
    isAnswered: true,
    isValid: true,
    answer: 'true',
    id: '628241eb92265b0020539780'
  }
];
